import Vue from 'vue';
import { serverTableOptions, toastrOptions } from './options';
import Vselect from 'vue-select';
import BootstrapVue from 'bootstrap-vue';
import miniToastr from 'mini-toastr';

// Notification messages initialization
const notification = {
    install(Vue, options) {
        Vue.prototype.$Notification = miniToastr.init(toastrOptions);
    }
};

const mods = [
    { modName: BootstrapVue },
    { modName: notification }
];

const components = [
    { name: Vselect, id: 'v-select' }
];

mods.forEach(mod => Vue.use(mod.modName, (mod.option) ? mod.option : null));
components.forEach(component => Vue.component(component.id, component.name));



// WEBPACK FOOTER //
// ./src/thirdparty/index.js